import { Button, Flex, Space } from '@mantine/core';
import * as C from '../../../../ui/common/CommonStyles';
import CompanyInfo from './companyInfo/CompanyInfo';
import ServiceChannel from './channel/ServiceChannel';
import ModelList from './modelList/ModelList';
import { IconChevronLeft } from '@tabler/icons-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetCompanyDetails } from '../../../../../shared/apis/company/reactQueries';

export default function CompanyDetails() {
  const navigate = useNavigate();
  const params = useParams();
  const companyId = params.companyId || '';

  const { data: companyDetails, isLoading } = useGetCompanyDetails({ companyId: Number(companyId) });

  const companyInfo = {
    companyId: Number(companyId),
    data: {
      email: companyDetails?.companyDetail.email,
      name: companyDetails?.companyDetail.name,
      tel: companyDetails?.companyDetail.tel,
    },
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">거래처 상세</div>
      </C.TitleBox>
      {!isLoading && (
        <C.ListBox>
          <CompanyInfo data={companyDetails?.companyDetail} />
          <Space h="lg" />
          <ServiceChannel data={companyDetails?.channels} companyInfo={companyInfo} />
          <Space h="lg" />
          <ModelList companyId={companyId} />
        </C.ListBox>
      )}
      <Flex justify="center" my="lg">
        <Button
          variant="default"
          leftSection={<IconChevronLeft size={16} />}
          onClick={() => navigate('/admin/management/company')}
        >
          목록으로
        </Button>
      </Flex>
    </div>
  );
}
